//M10-12866
import { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/context/store";
import FilterAccordion from "./FilterAccordion";
import { Button } from "src/components";
import { ordPoActions } from "src/context/order-po-slice";

interface FilterItem {
  id?: string;
  name?: string;
  code?: string | number;
  [key: string]: any; // Add an index signature
}

interface OrdersPOFilter {
  onCloseClick: () => void;
  companyDetails: FilterItem[];
  pendingStatus?: FilterItem[];
  stockistDetails: FilterItem[];
  counterDetails?: FilterItem[];
}

const Divider = () => <div className="w-full h-[0.0625rem] my-2 bg-[#0000001a]" />;

const OrdersPOFilter = forwardRef<HTMLElement, OrdersPOFilter>(({ companyDetails, pendingStatus, stockistDetails, counterDetails }, ref) => {
    console.log(companyDetails, pendingStatus, stockistDetails,"VVVVV")
  const dispatch = useDispatch();

  const companyFilterHandler = (details: FilterItem[]) => {
    dispatch(ordPoActions.setOrderPoFilters({ key: "company", value: details }));
  };

  const statusFilterHandler = (details: FilterItem[]) => {
    dispatch(ordPoActions.setOrderPoFilters({ key: "status", value: details }));
  };
  const stockistFilterHandler = (details: FilterItem[]) => {
    dispatch(ordPoActions.setOrderPoFilters({ key: "stockist", value: details }));
  };
  // M10-15868
  const counterFilterHandler = (details: FilterItem[]) => {
    dispatch(ordPoActions.setOrderPoFilters({ key: "counter", value: details }));
  };
  // M10-15868

  const resetFilter = () => {
    dispatch(ordPoActions.setOrderPoFilters({ key: "company", value: [] }));
    dispatch(ordPoActions.setOrderPoFilters({ key: "status", value: [] }));
    dispatch(ordPoActions.setOrderPoFilters({ key: "stockist", value: [] }));
    dispatch(ordPoActions.setOrderPoFilters({ key: "counter", value: [] })); //M10-15868

    dispatch(ordPoActions.setIsResetFilter(false));
  };

  const filters = useSelector((state: RootState) => state.ordPoState.OrderPoFilters);

  return (
    <aside
      className="bg-white border-l-[1px] min-w-[20rem] overflow-y-auto max-w-[25rem] border-l-[#00000014] fixed px-8 text-[#49484C] text-xl font-semibold py-5 right-0  h-screen"
      ref={ref}
    >
      <div className="flex items-center justify-between gap-5 mt-3">
        <h3 className="whitespace-nowrap">Fetch filters</h3>
        <Button className="border py-1 bg-[#7F56D9] text-white" onClick={resetFilter}>
          Reset
        </Button>
      </div>

      {/* filters  */}
      <div className="flex flex-col ">
        <FilterAccordion
          uniqueKey="code"
          displayKey="shortname"
          onSelectingFilter={companyFilterHandler}
          title="Company Name"
          arrayToFilter={companyDetails}
          defaultValue={filters.company}
          isSingleSelect={true}
        />
        <Divider />
        <FilterAccordion
          uniqueKey="stockist_id"
          displayKey="owner_name"
          title="Stockist"
          arrayToFilter={stockistDetails}
          onSelectingFilter={stockistFilterHandler}
          defaultValue={filters.stockist}
          isSingleSelect={true}
        />
        <Divider />
        {/* M10-15868 */}
        <FilterAccordion
          uniqueKey="counter_code"
          displayKey="counter_display"
          title="Counter"
          arrayToFilter={counterDetails || []}
          onSelectingFilter={counterFilterHandler}
          defaultValue={filters.counter}
          isSingleSelect={true}
        />
        {/* M10-15868 */}
        <Divider />

        {/* {pendingStatus && pendingStatus?.length > 0 && ( */}
        {
          <>
            <FilterAccordion
              displayKey="poid_status_desc"
              title="Status"
              arrayToFilter={pendingStatus || []}
              uniqueKey="poid_status_id"
              onSelectingFilter={statusFilterHandler}
              defaultValue={filters.status}
              isSingleSelect={true}
            />
          </>
        }
      </div>
    </aside>
  );
});

export default OrdersPOFilter;
//M10-12866